document.addEventListener("DOMContentLoaded", () => {
  let notifyMeSubmitButton = document.querySelector(
    ".td-product-confirm-email_notify_me"
  );

  let notifyMeError = document.querySelector(".notify-me-form-error-text");
  let notifyMeMessage = document.querySelector(".notify-me-form-message-text");
  

    let isFormSubmitted = false; // Flag to track form submission

    notifyMeSubmitButton.addEventListener("click", function (event) {
      if (isFormSubmitted && grecaptcha.getResponse() == "") {
        notifyMeMessage.style.display = "none";
        document.querySelector(".g-recaptcha").style.display = "block"; // Show the reCAPTCHA
        event.preventDefault(); // Prevent form submission
        notifyMeError.textContent = "Please complete the reCAPTCHA"; // Display error message
        notifyMeError.style.display = "block";
      } else {
        document.querySelector(".g-recaptcha").style.display = "none"; // Don't display reCAPTCHA
        let checkboxElement = document.getElementById("optInEmail");
        let isChecked = checkboxElement.checked; // This line gets the checked state of the checkbox

        let emailInput = document.querySelector(".td-product-confirm-email__input").value;
        let productNameInput = document.querySelector(".td-product-confirm-product_name_input").value;
        let skuInput = document.querySelector(".td-product-confirm-sku_input").value;

        let email = emailInput.trim().toLowerCase();

        if (validateEmail(email)) {
          if (productNameInput === '' && skuInput === '') {
            notifyMeError.textContent = "Please enter a valid product name or SKU"; // Display error message for invalid email
            notifyMeError.style.display = "block";
          } else{
            const currentTime = new Date().toLocaleString();
            
            notifyMeError.style.display = "none";

            notifyMeMessage.style.color = "#F49691"; // Change text color to pink
            notifyMeMessage.textContent = "Adding to list...";
            notifyMeMessage.style.display = "block";

            fetch("https://sheetdb.io/api/v1/lqone4jw9iwmv", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },

              body: JSON.stringify({
                data: [
                  {
                    "Email": email,
                    "SKU": skuInput,
                    "Product Name": productNameInput,
                    "Date/Time": currentTime,
                    "Marketing Opt In": isChecked,
                  },
                ],
              }),
            })
              .then((response) => {
                
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}, ... ${response.statusText}`);
                }
                isFormSubmitted = true; // Set the flag to true after the first submission
                notifyMeMessage.style.color = "var(--body_font_color)";
                notifyMeMessage.textContent = "Successfully added!!";
                notifyMeMessage.style.display = "block";
                return response.json();
              })
              .then((data) => console.log(data))
              .catch((error) => {
                console.error("Fetch error:", error);
                notifyMeError.textContent = "Error submitting. Please try again"; // Handle error here
                notifyMeError.style.display = "block";
              });

            fetch("https://ayx6r7es6w3emmf6gzledvd5fy0itzhx.lambda-url.us-east-2.on.aws/", {
              method: "POST",
              mode: "cors",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },

              body: JSON.stringify({
                data: [
                  {
                    "Email": email,
                    "SKU": skuInput,
                    "Product Name": productNameInput,
                    "Date/Time": currentTime,
                    "Marketing Opt In": isChecked,
                    "No Search Result": false
                  },
                ],
              }),
            })
              .then((response) => {
                
                if (!response.ok) {
                  throw new Error(`HTTP error! Status: ${response.status}, ... ${response.statusText}`);
                }
                isFormSubmitted = true; // Set the flag to true after the first submission
                // notifyMeMessage.style.color = "var(--body_font_color)";
                // notifyMeMessage.textContent = "Successfully added!!";
                // notifyMeMessage.style.display = "block";
                return response.json();
              })
              .then((data) => console.log(data))
              .catch((error) => {
                console.error("Fetch error:", error);
                notifyMeError.textContent = "Error submitting. Please try again"; // Handle error here
                notifyMeError.style.display = "block";
              });

            isFormSubmitted = true; // Set the flag to true after the first submission
          }
        } else {
          notifyMeError.textContent = "Please enter a valid email"; // Display error message for invalid email
          notifyMeError.style.display = "block";
        }
      }
    });
});

const validateEmail = (email) => {
  const emailPattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailPattern.test(email.toLowerCase());
};

